// extracted by mini-css-extract-plugin
export default {"container":"wideCard_container__3xXH2"};